import { render, staticRenderFns } from "./ManifestKlaimPd.vue?vue&type=template&id=52844b7e&scoped=true&"
import script from "./ManifestKlaimPd.vue?vue&type=script&lang=js&"
export * from "./ManifestKlaimPd.vue?vue&type=script&lang=js&"
import style0 from "./ManifestKlaimPd.vue?vue&type=style&index=0&id=52844b7e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52844b7e",
  null
  
)

export default component.exports